// Perfil CONTADOR: usuario de fora da empresa que so ve a revisao da
// classificacao tributaria (IBS/CBS). Reconhecido pelas permissoes: todas do
// recurso revisao_tributaria. O backend barra as outras rotas
// (Middleware.PerfilRestrito); aqui so evitamos abrir telas que dariam 403.
// A chave comeca com "session" para o clearSession do logout apagar junto.

export const RECURSO_CONTADOR = 'revisao_tributaria';
export const ROTA_CONTADOR = '/fiscal/revisao-tributaria';
const CHAVE = 'sessionPerfilContador';

export const ehPerfilContador = (perms) =>
  Array.isArray(perms) && perms.length > 0 && perms.every((p) => (p?.recurso || '') === RECURSO_CONTADOR);

export const marcarPerfilContador = (perms) => {
  try {
    if (ehPerfilContador(perms)) localStorage.setItem(CHAVE, '1');
    else localStorage.removeItem(CHAVE);
  } catch {
    // sem localStorage: o backend continua barrando
  }
};

export const usuarioEhContador = () => {
  try {
    return localStorage.getItem(CHAVE) === '1';
  } catch {
    return false;
  }
};
